import React, { useState, useEffect } from 'react'
import { numberParseChina, formatNum } from "@/utils/utils";
import { useAppointmentModel } from '../appointmentModel';
import { appointmentService } from "../appointmentService"
import { IMaterialDetailList, IItemDetailList, IAppointmentDetail } from '../appointmentType';
import { SettlePrint, IPrintClumns } from "@/components/settlePrint"
import moment from 'moment';
import { useDictModel } from '@/views/base/dict/dictModel';
import useGlobalModel from '@/model/globalModel';
export const Print = () => {
    const {
        print: visible,
        selectedRow,
        setPrint,
        loadData
    } = useAppointmentModel();
    const { getTreeNodeName } = useDictModel();
    const { CustomerData, shopAndOrg: { shopName, shopId } } = useGlobalModel()
    const [formVal, setFormVal] = useState<IAppointmentDetail>({});
    const [maintenanceList, setMaintenanceList] = useState<IMaterialDetailList[]>([]);
    const [itemList, setItemList] = useState<IItemDetailList[]>([]);
    useEffect(() => {
        visible && getDetailOne()
    }, [visible])
    const getDetailOne = async () => {
        let { retData } = await appointmentService.one(selectedRow.appointmentCode as string);
        let { itemDetails, materialDetails, receivableTotalAmount, enterTime, ...from } = retData
        receivableTotalAmount = formatNum(receivableTotalAmount)
        const newItemDetails = itemDetails?.map((item, index) => {
            return {
                ...item,
                No: index + 1
            }
        })
        const newMaterialDetails = materialDetails?.map((item, index) => {
            return {
                ...item,
                No: index + 1
            }
        })
        if (retData) {
            setMaintenanceList(newMaterialDetails as IMaterialDetailList[] ?? []);
            setItemList(newItemDetails as IItemDetailList[] ?? []);
            setFormVal({ ...from, receivableTotalAmount, receivableTotalAmountCN: numberParseChina(receivableTotalAmount), enterTime: moment(enterTime).format("YYYY-MM-DD HH:mm") })
        }
    }
    const printNum = async () => {
        await appointmentService.printNum(selectedRow.id as string);
        await loadData();
    }
    const onClose = () => {
        setPrint(false)
    }
    const itemClumns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '项目编号',
            dataIndex: 'itemCode',
        },
        {
            title: '项目名称',
            dataIndex: 'itemName',
        },
        {
            title: '工时费',
            dataIndex: 'receivableAmount',
        },
        {
            title: '工时',
            dataIndex: 'workHour',
        },
        // {
        //     title: '单价',
        //     dataIndex: 'price',
        // },
        // {
        //     title: '折扣',
        //     dataIndex: 'discountRate',
        //     render: (text: string) => text + "%"
        // },
        // {
        //     title: '备注',
        //     dataIndex: 'note',
        // },
        {
            title: '实际工时',
            dataIndex: 'workHour',
        },
    ]
    const columns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '材料编号',
            dataIndex: 'materialCode',
        },
        {
            title: '材料名称',
            dataIndex: 'materialName',
        },
        {
            title: '单位',
            dataIndex: 'unitName',
        },
        {
            title: '数量',
            dataIndex: 'num',
        },
        {
            title: '单价',
            dataIndex: 'price',
        },
        // {
        //     title: '折扣',
        //     dataIndex: 'discountRate',
        //     render: (text: string) => text + "%"
        // },
        {
            title: '金额',
            dataIndex: 'receivableAmount',
        },
        {
            title: '备注',
            dataIndex: 'note',
        },
    ]
    let IHeader = [
        {
            fieldLabel: "单据编号：",
            fieldValue: `${formVal.appointmentCode}    (${getTreeNodeName(formVal.status)})`
        }, {
            fieldLabel: "结算类型：",
            fieldValue: ""

        }, {
            fieldLabel: "打印日期：",
            fieldValue: moment(new Date()).format("YYYY-MM-DD HH:mm")
        },
    ]
    return (
        <SettlePrint
            title={`${shopName}修理结算单`}
            visible={visible}
            onClose={onClose}
            columns={columns as IPrintClumns[]}
            itemClumns={itemClumns as IPrintClumns[]}
            itemDataSource={itemList}
            dataSource={maintenanceList.filter(item => item.num !== 0)}
            printHeader={formVal}
            printFooter={formVal}
            IHeader={IHeader}
            printNum={printNum}
        />

    )
}